import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('pagamento_verbas_estruturais', 'integracao');

const pagamentoActions = {
  reenviar: { method: 'PUT', url: `${basePath}/reenviar` },
};

export default resource => resource(`${basePath}`, {}, pagamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/pagamento-integracao.js